"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterSharpshooterAbilityHandler = exports.MasterSharpshooterActorAbilityFactory = exports.MasterSharpshooterAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class MasterSharpshooterAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MasterSharpshooter;
        this.__typeName = "MasterSharpshooter";
    }
}
exports.MasterSharpshooterAbilityArgs = MasterSharpshooterAbilityArgs;
let MasterSharpshooterActorAbilityFactory = class MasterSharpshooterActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MasterSharpshooter", "Self", 0);
    }
};
MasterSharpshooterActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MasterSharpshooter")
], MasterSharpshooterActorAbilityFactory);
exports.MasterSharpshooterActorAbilityFactory = MasterSharpshooterActorAbilityFactory;
let MasterSharpshooterAbilityHandler = class MasterSharpshooterAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.MasterSharpshooterEffectArgs(),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
MasterSharpshooterAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MasterSharpshooter)
], MasterSharpshooterAbilityHandler);
exports.MasterSharpshooterAbilityHandler = MasterSharpshooterAbilityHandler;
